import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"

const mapParams = (params: SummaryReportParams) => {
  return {
    AccountTypeID: params.AccountTypeID,
    ColumnFilters: {},
    DateFrom: '',
    DateTo: '',
    Exact: false,
    Filters: {
      Company: params.Company,
      DateRange: params.DateRange,
      DateType: params.DateType,
      EndDate: params.DateTo,
      Location: [],
      Reason: [],
      Region: [],
      Regulated: "Regulated & Non-Regulated",
      Service: [],
      StartDate: params.DateFrom,
      Status: "In Process"
    },
    InProcessStatus: true,
    IsMarketPlace: true,
    IsReviewed: false,
    IncludeArchived: params.IncludeArchived,
    Mask: "",
    Pending: true,
    SearchBy: "AllIDs",
    Type: "All"
  }
}

export interface SummaryReportParams {
  AccountTypeID: number,
  Company: string[],
  DateRange: string,
  DateType: string,
  DateFrom: string,
  DateTo: string,
  IncludeArchived: boolean
}

export function SummaryReportGetCsv(params: SummaryReportParams): Observable<string> {
  const requestBody: string = JSON.stringify(mapParams(params))
  return ObservableFromFetch<string>("WorkforceTrack/ExportTrackRecord", requestBody)
}

export default function SummaryReportPdf(params: SummaryReportParams): Observable<string> {
  const requestBody: string = JSON.stringify(mapParams(params))
  return ObservableFromFetch<string>("WorkforceReport/SummaryReport", requestBody)
}
